/** Keep list preferences while removing the document navigation levels. */
export function inboxRootUrl(search: string): string {
  const params = new URLSearchParams(search);
  ["owner", "item", "mode", "view"].forEach((key) => params.delete(key));
  return `/ladica${params.size ? `?${params}` : ""}`;
}
export function inboxUpParams(current: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(current);
  if (next.get("mode") === "process") next.delete("mode");
  else if (next.has("item")) next.delete("item");
  else next.delete("owner");
  return next;
}
